import {
  Box,
  Button,
  Flex,
  FormLabel,
  Select,
  Text,
  useColorModeValue,
  useToast,
  Table,
  Thead,
  Tbody,
  Td,
  Tr,
  Th,
  Spinner,
   Input,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import React, { useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useForm, Controller } from "react-hook-form";
import { useBookingActions } from "hooks/useBookingActions";
import { BsSearch } from "react-icons/bs";
import { RxReset } from "react-icons/rx";
import DatePickerInput from "components/CustomDateInput/CustomDateInput";
import { RiFileExcel2Fill } from "react-icons/ri";
import { totalRow } from "state/roles-permissions";

import {
  listShowAtom,
  venueListAtom,
  listTheaterPassAtom,
  showTimeListAtom,
} from "../../state/show";
import { getFirstAndLastDate } from "helpers/date";
import SearchTable2 from "components/Tables/SearchTable2";

import { columnsDataScanTheaterPass } from "variables/columnsData";
import ExportButton from 'components/Button/ExportButton';

function DataTableTheaterPassReport() {
  const textColor = useColorModeValue("gray.700", "white");
  const toast = useToast();
  const totalRows = useRecoilValue(totalRow);
  const bookingActions = useBookingActions();
  const listShow = useRecoilValue(listShowAtom);
  const venueList = useRecoilValue(venueListAtom);
  const listTheater = useRecoilValue(listTheaterPassAtom);
  const showTimeList = useRecoilValue(showTimeListAtom);
  const setListTheater = useSetRecoilState(listTheaterPassAtom);
  const [isFetching, setIsFetching] = useState(true);
  const [highlightDate, setHighlightDate] = useState([]);
  const [newScanTheaterPass, setScanTheaterPass] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const currentPageSizeStore = localStorage && localStorage.getItem("currentPageSizeStore");
  const [pageSize, setPageSize] = useState(currentPageSizeStore ? parseInt(currentPageSizeStore) : 10);
  const [refreshPagingDefault, setRefreshPagingDefault] = useState(false);
  const [listCheckedChoose, setListCheckedChoose] = useState([]);
  const [isExportExcel, setIsExportExcel] = useState(false);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const  [listSumaryOntimeTotal, setSumaryOntimeTotal] = useState({
    aah: 0,
    ooh: 0,
    wow: 0,
    total: 0,
  });
  const  [listSumaryLateTotal, setSumaryLateTotal] = useState({
    aah: 0,
    ooh: 0,
    wow: 0,
    total: 0,
  });

  const [hasSearched, setHasSearched] = useState(false);
  
  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    control: controlSearch,
    watch: watchSearch,
    reset: resetSearch,
    setValue: setValueSearch,
    formState,
  } = useForm({
  defaultValues: {
    showTimeSearch: "18:00",
  }
});
  const { errors, isSubmitting } = formState;
  const showSearch = watchSearch("showSearch");
  const showTimeSearch = watchSearch("showTimeSearch");
  const venueSearch = watchSearch("venueSearch");
  const bookingCodeSearch = watchSearch('bookingCodeSearch');
  const allSearchValues = watchSearch();

  useEffect(() => {
    if (hasSearched) {
      setIsFilterDirty(true);
    }
  }, [JSON.stringify(allSearchValues)]);

  useEffect(async () => {
    setIsFetching(true);

    // Load dropdown data
    bookingActions.getListShow({ status: 1 }, 0, "");
    bookingActions.getListVenue({ status: 1 }, 0, "");
    bookingActions.getListShowTime({ status: 1 }, 0, "");
    setValueSearch("show_date", new Date());
    setIsFetching(false);
  }, []);

  async function onSubmitSearch({ bookingCodeSearch, showSearch, venueSearch, showTimeSearch, type, isCheckinOnline }) {
    const show_date = watchSearch("show_date");

    if (!show_date) {
      toast({
        description: 'Please select Show Date before searching.',
        status: 'warning',
        duration: 4000,
        isClosable: true,
        position: 'top-right',
      });
      if (isExportExcel) setIsExportExcel(false);
      return;
    }

    const paramSearch = {
      booking_code: bookingCodeSearch,
      show_id: showSearch,
      venue_id: venueSearch,
      show_time: showTimeSearch,
      type,
      is_checkin_online: isCheckinOnline !== '' ? isCheckinOnline : undefined,
      show_date: new Date(
        show_date.setHours(0, 0, 0, 0)
      ).toISOString()
    };

    if (isExportExcel) {
      setIsExportExcel(false);
      const response =  await bookingActions.exportScanTheaterPassShow(paramSearch);
      const outputFilename = `scan_theater_pass_report_${Date.now()}.xlsx`;
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
      return;
    }
    setIsFetching(true);

    await bookingActions.getListTheaterPassShow(paramSearch);
    setIsFetching(false);
    setHasSearched(true);
    setIsFilterDirty(false);
  }

  const handleCalendarOpen = async (year, month, isFrom = false) => {
    setHighlightDate([]);
    
    const targetYear =
      year ||
      new Date(
        isFrom ? watchSearch("show_date") : watchSearch("show_date")
      ).getFullYear();
    const targetMonth =
      month ??
      new Date(
        isFrom ? watchSearch("show_date") : watchSearch("show_date")
      ).getMonth();

    const { firstDate, lastDate } = getFirstAndLastDate(
      targetYear,
      targetMonth
    );

    try {
      const res = await bookingActions.getShowsSchedule({
        show_id: showSearch,
        venue_id: venueSearch,
        from_date: firstDate,
        to_date: lastDate,
      });

      if (res) {
        const dateHighlight = res.map((item) => {
          const date = new Date(item.showdate);
          return isNaN(date.getTime()) ? null : date;
        }).filter(date => date !== null);
        setHighlightDate(dateHighlight);
      } else {
        setHighlightDate([]);
      }
    } catch (error) {
      setHighlightDate([]);
      setError("apiError", { message: "Failed to fetch show schedule" });
    }
  };

  const recallApi = async (fetchDataOptions) => {
    // Nếu chỉ thay đổi pagination (pageIndex, pageSize) và không có sort_field
    // thì không cần call API vì data đã có full từ backend
    if (!fetchDataOptions.sort_field && hasSearched && newScanTheaterPass.length > 0) {
      // Chỉ update pagination trên frontend
      updatePaginatedData(newScanTheaterPass, fetchDataOptions.pageIndex, fetchDataOptions.pageSize);
      setIsFetching(false);
      return;
    }

    setIsFetching(true);
    const showDateField = watchSearch("show_date") || new Date();
    const isCheckinOnlineValue = watchSearch("isCheckinOnline");
    const paramSearch = {
      booking_code: bookingCodeSearch,
      show_id: showSearch,
      venue_id: venueSearch,
      show_time: showTimeSearch,
      type: watchSearch("type"),
      is_checkin_online: isCheckinOnlineValue !== '' ? isCheckinOnlineValue : undefined,
      sort_field: fetchDataOptions.sort_field,
      sort_type: fetchDataOptions.sort_type,
      show_date: new Date(showDateField.setHours(0, 0, 0, 0)).toISOString()
    };

    if (hasSearched) {
      await bookingActions.getListTheaterPassShow(
        paramSearch,
        fetchDataOptions.pageIndex,
        fetchDataOptions.pageSize
      );
    }

    setIsFetching(false);
  };

  const getValueChecked = (val) => {
    if (val) {
      const checkedIDs = Object.keys(val);
      setListCheckedChoose(checkedIDs);
    }
  };

  const updatePaginatedData = (data, pageIndex = 0, pageSizeValue = 10) => {
    const startIndex = pageIndex * pageSizeValue;
    const endIndex = startIndex + pageSizeValue;
    const slicedData = data.slice(startIndex, endIndex);
    setPaginatedData(slicedData);
    setCurrentPage(pageIndex);
    setPageSize(pageSizeValue);
  };

  const handleTotalSumary = () => {
    const ontimeData = listTheater.filter((item) => item.type === 1);
    const lateData = listTheater.filter((item) => item.type === 2);
    setSumaryOntimeTotal({
      aah: ontimeData.reduce((total, item) => item.zone_name === 'aah! [A]' ? total + 1 : total, 0), //aah! [A]
      ooh: ontimeData.reduce((total, item) => item.zone_name === 'ooh! [O]' ? total + 1 : total, 0),
      wow: ontimeData.reduce((total, item) => item.zone_name === 'wow! [W]' ? total + 1 : total, 0),
      total: ontimeData.length,
    })
    setSumaryLateTotal({
      aah: lateData.reduce((total, item) => item.zone_name === 'aah! [A]' ? total + 1 : total, 0), //aah! [A]
      ooh: lateData.reduce((total, item) => item.zone_name === 'ooh! [O]' ? total + 1 : total, 0),
      wow: lateData.reduce((total, item) => item.zone_name === 'wow! [W]' ? total + 1 : total, 0),
      total: lateData.length,
    })
  }

  useEffect(() => {
    if (listTheater && listTheater.length > 0) {
      setScanTheaterPass(listTheater);
      handleTotalSumary();
      updatePaginatedData(listTheater, 0, pageSize);
    } else {
      setScanTheaterPass([]);
      setPaginatedData([]);
      setHighlightDate([]);
      setSumaryOntimeTotal({
        aah: 0,
        ooh: 0,
        wow: 0,
        total: 0,
      });
      setSumaryLateTotal({
        aah: 0,
        ooh: 0,
        wow: 0,
        total: 0,
      });
    }
  }, [listTheater]);

  // Clear data khi component unmount
  useEffect(() => {
    return () => {
      setListTheater([]);
    };
  }, []);

  return (
    <Card px="0px">
      <CardHeader px="22px" mb="12px">
        <Flex direction="column" display="block">
          <Text
            float="left"
            color={textColor}
            fontSize="lg"
            fontWeight="bold"
            mb="6px"
          >
            Scan Theater Pass Report
          </Text>
        </Flex>
      </CardHeader>
      <CardBody>
        <Flex ml="22px"></Flex>
        <Card>
          <form
            id="booking-search-form"
            onSubmit={handleSubmitSearch(onSubmitSearch)}
          >
            <Flex
              direction="row"
              alignItems="center"
              mb={3}
              gap={4}
              flexWrap={"wrap"}
            >
              <Box direction="row" alignItems="center" display="block">
                <FormLabel fontWeight="semibold" fontSize="xs" ms="4px">
                  Show
                </FormLabel>
                <Select
                  ms="4px"
                  type="text"
                  defaultValue="0"
                  size="sm"
                  id="showSearch"
                  name="showSearch"
                  {...registerSearch("showSearch")}
                  width="100px"
                >
                  <option value="">All</option>
                  {listShow.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction="row" alignItems="center" display="block">
                <FormLabel fontWeight="semibold" fontSize="xs" ms="4px">
                  Venue
                </FormLabel>
                <Select
                  ms="4px"
                  type="text"
                  size="sm"
                  id={"venueSearch"}
                  name="venueSearch"
                  {...registerSearch("venueSearch")}
                >
                  <option value="">All</option>
                  {venueList.map((i) => (
                    <option key={i.id} value={i.id}>
                      {i.name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction="row" alignItems="center" display="block">
                <FormLabel ms="4px" fontSize="sm" fontWeight="bold">
                  Show Date
                </FormLabel>
                <Controller
                  name="show_date"
                  control={controlSearch}
                  render={({ field }) => (
                    <DatePickerInput
                      onChange={(value) => {
                        if (value) {
                          handleCalendarOpen(
                            value.getFullYear(),
                            value.getMonth(),
                            true
                          );
                        }
                        field.onChange(value);
                      }}
                      onCalendarOpen={() => {
                        const showDate = watchSearch("show_date");
                        if (showDate) {
                          handleCalendarOpen(
                            showDate.getFullYear(),
                            showDate.getMonth(),
                            true
                          );
                        }
                      }}
                      onMonthChange={(date) => {
                        handleCalendarOpen(
                          date.getFullYear(),
                          date.getMonth(),
                          true
                        );
                      }}
                      onYearChange={(date) => {
                        handleCalendarOpen(
                          date.getFullYear(),
                          date.getMonth(),
                          true
                        );
                      }}
                      mask="99/99/9999"
                      selected={watchSearch("show_date")}
                      highlightDates={highlightDate}
                      selectsStart
                      minDate={new Date("01/01/2020")}
                    />
                  )}
                />
              </Box>
              <Box direction="row" alignItems="center" display="block">
                <FormLabel fontWeight="semibold" fontSize="xs" ms="4px">
                  Show Time
                </FormLabel>
                <Select
                  ms="4px"
                  type="text"
                  defaultValue={showTimeList[0]?.name || ""}
                  size="sm"
                  name="showTimeSearch"
                  {...registerSearch("showTimeSearch")}
                >
                  {/* <option value=''>All</option> */}
                  {showTimeList.map((item, index) => (
                    <option key={index} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction="row" alignItems="center" display="block">
                <FormLabel fontWeight="semibold" fontSize="xs" ms="4px">
                  Type
                </FormLabel>
                <Select
                  ms="4px"
                  type="text"
                  defaultValue={showTimeList[0]?.name || ""}
                  size="sm"
                  name="type"
                  {...registerSearch("type")}
                >
                    <option value=''>All</option>
                    <option value='1'>On time</option>
                    <option value='2'>Late</option>
                </Select>
              </Box>
              <Box direction="row" alignItems="center" display="block">
                <FormLabel fontWeight="semibold" fontSize="xs" ms="4px">
                  Check In Online
                </FormLabel>
                <Select
                  ms="4px"
                  type="text"
                  size="sm"
                  name="isCheckinOnline"
                  {...registerSearch("isCheckinOnline")}
                >
                  <option value=''>All</option>
                  <option value='true'>Yes</option>
                  <option value='false'>No</option>
                </Select>
              </Box>
            </Flex>
            <Text color="red" fontSize={14}>
              {Object.values(errors)[0]?.message}
            </Text>

            <Flex justify="center" align="center" gap="8px" mt={3}>
              <Box direction="row" alignItems="center" display="block">
                <Button
                  leftIcon={<RxReset />}
                  variant="primary"
                  w="88px"
                  h="33px"
                  onClick={() => {
                    resetSearch();
                    setValueSearch("show_date", new Date());
                    setListTheater([]);
                    setHasSearched(false);
                    setIsFilterDirty(false);
                    setHighlightDate([]);
                  }}
                >
                  Reset
                </Button>
              </Box>
              <Box direction="row" alignItems="center" display="block">
                <Button
                  leftIcon={<RiFileExcel2Fill />}
                  variant="primary"
                  h="33px"
                  type="submit"
                  isDisabled={!hasSearched || newScanTheaterPass.length === 0 || isFilterDirty}
                  onClick={() => {
                    setIsExportExcel(true);
                  }}
                >
                  Export Excel
                </Button>
              </Box>
              <Box direction="row" alignItems="center" display="block">
                <Button
                  leftIcon={<BsSearch />}
                  variant="primary"
                  w="88px"
                  h="33px"
                  type="submit"
                >
                  Search
                </Button>
              </Box>
            </Flex>
          </form>
        </Card>
        <Box overflowX="auto">
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th color="white" colSpan="3" backgroundColor="blue.600">
                      SHOW TIME:
                    </Th>
                    <Th color="white" colSpan="2" backgroundColor="blue.600">
                      <Text fontWeight="bold" textAlign="end" mb={2}>
                        {watchSearch("show_date") ? watchSearch("show_date").toLocaleDateString() : ""}   {watchSearch("showTimeSearch") ? watchSearch("showTimeSearch") : "All"}
                      </Text>
                    </Th>
                  </Tr>
                  <Tr>
                    <Th w="450px"></Th>
                    <Th textAlign="center">aah![A]</Th>
                    <Th textAlign="center">ooh![O]</Th>
                    <Th textAlign="center">wow![W]</Th>
                    <Th textAlign="center">Total</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                      <Td>The number of theater pass scans before the show</Td>
                      <Td textAlign="center">{listSumaryOntimeTotal.aah}</Td>
                      <Td textAlign="center">{listSumaryOntimeTotal.ooh}</Td>
                      <Td textAlign="center">{listSumaryOntimeTotal.wow}</Td>
                      <Td textAlign="center">{listSumaryOntimeTotal.total}</Td>
                  </Tr>
                  <Tr>
                      <Td>The number of theater pass scans after the show</Td>
                      <Td textAlign="center">{listSumaryLateTotal.aah}</Td>
                      <Td textAlign="center">{listSumaryLateTotal.ooh}</Td>
                      <Td textAlign="center">{listSumaryLateTotal.wow}</Td>
                      <Td textAlign="center">{listSumaryLateTotal.total}</Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>
        <div className="header-blue-600">
          <SearchTable2
            tableData={paginatedData}
            columnsData={columnsDataScanTheaterPass}
            totalRow={newScanTheaterPass.length}
            listPermissions={[69]}
            actionsActive={["publish"]}
            loadData={(fetchDataOptions) => recallApi(fetchDataOptions)}
            isFetching={isFetching}
            enableRowSelection
            updateCheckbox={(val) => getValueChecked(val)}
            conditionShowSelect={`(row) => row.original.invoice_status === 0`}
            refreshPagingDefault={refreshPagingDefault}
            sizeAllColumns={10}
          />
        </div>
      </CardBody>
    </Card>
  );
}

export default DataTableTheaterPassReport;
